export default function ShippingPolicy() {
    return (
        <div className="container-tight max-w-3xl py-16 lg:py-24" data-testid="shipping-policy-page">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
                Legal
            </p>
            <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
                Shipping &amp; Delivery Policy
            </h1>
            <p className="mt-4 text-sm text-slate-500">Last updated: 11 June 2026</p>

            <div className="prose prose-slate dark:prose-invert mt-10 max-w-none text-slate-600 dark:text-slate-400 leading-relaxed space-y-6">
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        1. Digital Service — No Physical Shipping
                    </h2>
                    <p>
                        TenderTrackAI is a 100% digital Software-as-a-Service product. We
                        do not sell or ship any physical goods, so no courier, logistics
                        or shipping charges apply to any purchase made on
                        tendertrackai.com.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        2. Instant Delivery of Plans &amp; Credits
                    </h2>
                    <p>
                        On successful payment (processed via Razorpay), your subscription
                        plan and analysis credits are activated{" "}
                        <strong>instantly and automatically</strong> on your TenderTrackAI
                        account. In rare cases of payment-gateway delays, activation may
                        take up to 30 minutes. You will see your updated plan and credit
                        balance in <strong>Dashboard → Billing</strong> immediately after
                        activation, and a payment confirmation is sent to your registered
                        email.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        3. Delivery of Analysis Reports
                    </h2>
                    <p>
                        AI tender analysis reports are generated online and delivered
                        within your dashboard, typically in under 60 seconds per document.
                        Reports remain accessible in your Analysis History for the
                        lifetime of your account.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        4. Activation Issues
                    </h2>
                    <p>
                        If your plan or credits are not visible within 30 minutes of a
                        successful payment, contact support@tendertrackai.com with your
                        payment reference ID. We resolve activation issues within 24
                        hours on business days.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        5. Contact
                    </h2>
                    <p>
                        TenderTrackAI Technologies Pvt. Ltd., Indiranagar, Bengaluru
                        560038, India · support@tendertrackai.com · +91 80-4444-2200
                        (Mon–Sat, 9am–7pm IST).
                    </p>
                </section>
            </div>
        </div>
    );
}
